(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-bubble-filters"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bubble-filters-carousel')) {
    customElements.define('bubble-filters-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bubble-track]');
        this.prevButton = this.querySelector('[data-bubble-prev]');
        this.nextButton = this.querySelector('[data-bubble-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.onPrev = () => this.scrollByPage(-1);
        this.onNext = () => this.scrollByPage(1);

        this.track.addEventListener('scroll', this.update, { passive: true });
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.update);
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      scrollByPage(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: 'smooth' });
      }

      // Fade/arrow on each side only while there is more content to scroll that way
      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const hasOverflow = maxScroll > 1;
        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft >= maxScroll - 1;

        this.toggleAttribute('data-fade-start', hasOverflow && !atStart);
        this.toggleAttribute('data-fade-end', hasOverflow && !atEnd);
        if (this.prevButton) this.prevButton.hidden = !hasOverflow || atStart;
        if (this.nextButton) this.nextButton.hidden = !hasOverflow || atEnd;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
